import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_DELETE_ENGAGEMENT_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_DELETE_ENGAGEMENT_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/OpenDeleteEngagementModal')
};